import Vue from 'vue';
// @ts-ignore
import fetch from '@/api/fetch';
// @ts-ignore
import _ from 'lodash';

const dictVue = new Vue({data: {dict: {}}});
const dictStore = dictVue.dict;
const requestDictList = new Set();
const url = '/dcpServiceOpmange/supervisor/adPosition/getItemList';
const debounceTime = 300;
/**
 * 说明：
 * 翻译字典的方法 td(val, dictName)
 *  dictName  不会对字典的value值的类型进行修改
 *  $dictName 会将字典的value值的类型转化成number
 *  !dictName 会将字典的value值的类型转化成boolean
 * 例子：src\views\MarketingMgr\operationManagement\pageManagement\List\index.vue  341行 this.td(row.isPublished, '!PAGE_PUBLISH_STATUS')
 *
 * 获取字典的方法 getDict(dicts) dicts需要请求字典的集合 返回promise
 */


/**
 * boolean化字典
 */
const booleanDict = dict => (dict && dict.map(v => ({ ...v, value: Boolean(+v.value) }))) || [];

/**
 * 数字化字典
 */
const digitalDict = (dict) => (dict && dict.map(dictItem => ({ ...dictItem, value: +dictItem.value }))) || [];
const symbolsMap = [
  { key: '$', methods: digitalDict },
  { key: '!', methods: booleanDict }
];
export default {
  install(Vue, option = {}) {
    Vue.mixin({
      methods: {
        /** 翻译数据字典 */
        td: transDict,
        /** 获取字典值 返回promise */
        getDict: getDictImmediately
      }
    });
  }
};
/**
 * 异步获取多个数据字典 返回promise
 * @param {string|string[]} codes
 */
const getDictImmediately = (codes) => {
  const dicts = _.flatten([codes]);
  const exitDicts = dicts
    .filter(dict => dictStore.hasOwnProperty(dict))
    .map(dict => dictStore[dict]);
  return exitDicts.length === dicts.length ? Promise.resolve(exitDicts) : fetchDict(dicts).then(([data, res]) => {
    if (res) console.error(res);
    data.forEach(({ code, data }) => {
      dictStore[code] = Object.freeze(data);
      dictStore[`$${code}`] = Object.freeze(digitalDict(data));
      dictStore[`!${name}`] = Object.freeze(booleanDict(data));
    });
    return data.map(dict => ({ code: dict.code, data: dict.data }));
  });
};

/**
 * 翻译字典
 * @param {string | number} val
 * @param {string | Array} dict
 * @param {any} option
 */
export const transDict = (val, dict, option = {}) => {
  if (Array.isArray(dict)) {
    const key = option.value || 'value';
    const name = option.name || 'name';
    const item = dict.find(v => v[key] === val);
    return item ? item[name] : val;
  }
  if (typeof dict === 'string') return transDict(val, getDictByStore(dict), option);
  // return 'dict is neither not a Array or string, please check dict type';
};
/**
 * 从仓库中获取字典
 * @param {string} code
 */
export const getDictByStore = (code) => {
  if (dictStore.hasOwnProperty(code)) return dictStore[code];
  const reg = new RegExp(/^[$!]/);
  return reg.test(code) ? withPrefixInitStore(code, code.slice(0, 1)) : initStoreDict(code);

  // if (code[0] === '$') {
  //   const dict = initStoreDict(code);
  //   const dictCode = code.slice(1);
  //   if (dictStore.hasOwnProperty(dictCode)) {
  //     dict.push(...digitalDict(dictStore[dictCode]));
  //   } else initStoreDict(dictCode);
  //   return dict;
  // }
  // if (code[0] === '!') {
  //   const dict = initStoreDict(code);
  //   const dictCode = code.slice(1);
  //   if (dictStore.hasOwnProperty(dictCode)) {
  //     dict.push(...booleanDict(dictStore[dictCode]));
  //   } else initStoreDict(dictCode);
  //   return dict;
  // }
  // return initStoreDict(code);
};
/**
 * 字典前面有前缀的时候 初始化字典
 * @param {string} code
 * @param {string} prefix
 */
const withPrefixInitStore = (code, prefix) => {
  const dict = initStoreDict(code);
  const dictCode = code.slice(1);
  const fn = symbolsMap.find(v => v.key === prefix).methods;
  if (dictStore.hasOwnProperty(dictCode)) {
    dict.push(...fn(dictStore[dictCode]));
  } else initStoreDict(dictCode);
  return dict;
};

/**
 * @description 在Store中初始化该数据字典
 */
const initStoreDict = dictCode => {
  dictVue.$set(dictStore, dictCode, []);
  const reg = new RegExp(/^[$!]/);
  if (!reg.test(dictCode)) {
    requestDictList.add(dictCode);
    getDictRemoteDebounce();
  }
  return dictVue.dict[dictCode];
};

/**
 * 设置字典仓库的值
 */
const getDictRemote = async() => {
  const dictCodes = [...requestDictList];
  requestDictList.clear();
  const [data, res] = await fetchDict(dictCodes);
  if (res) requestDictList.add(dictCodes);
  data.forEach(dictItem => {
    const name = dictItem.code;
    const dict = dictItem.data;
    dictStore[name] = Object.freeze(dict);
    dictVue.$emit(name, dictStore[name]);
    const $name = `$${name}`;
    if (dictStore.hasOwnProperty($name)) {
      dictStore[$name] = Object.freeze(digitalDict(dict));
      // dictVue.$emit($name, dictStore[$name]);
    }

    const isName = `!${name}`;
    if (dictStore.hasOwnProperty(isName)) {
      dictStore[isName] = Object.freeze(booleanDict(dict));
      // dictVue.$emit(isName, dictStore[$name]);
    }
  });
};
/**
 * 设置dictStore中字典的值
 */
const setDictItem = (prefixName, dict) => {
  if (dictStore.hasOwnProperty(prefixName)) {
    dictStore[prefixName] = Object.freeze(digitalDict(dict));
    // dictVue.$emit(prefixName, dictStore[prefixName]);
  }
};
/**
 * 获取字典值
 * @param {string[]} codes
 */
const fetchDict = async(codes) => {
  const params = codes.map(v => ({ code: v }));
  const { code, data, msg } = await fetch.post(url, params);
  if (code !== '0000') {
    console.error(msg);
    return [null, msg];
  } else return [data, null];
};

/**
 * @description 对数据字典请求进行防抖处理
 */
const getDictRemoteDebounce = _.debounce(getDictRemote, debounceTime);
